import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=47afec62&scoped=true&"
import script from "./AddToCartButton.vue?vue&type=script&lang=js&"
export * from "./AddToCartButton.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartButton.vue?vue&type=style&index=0&id=47afec62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47afec62",
  null
  
)

export default component.exports